// extracted by mini-css-extract-plugin
module.exports =  {"root":"hhTG_jrOroiZ4mte8Xgu"};